



































import Vue from 'vue';

export default Vue.extend({
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        operation(id) {
            this.$emit('update', id);
        },
        navToProductDetail(product) {
            this.$store.commit('currentProductInfo', product);
            const path = `/product/${product.productId}`;
            const { href } = this.$router.resolve({
                path,
            });
            window.open(href, '_blank');
        },
        navToBrandDetail(product) {
            this.$router.push({
                path: `/brand/${product.brandId}`,
            });
        },
    },
});
